module.exports = __webpack_public_path__ + "f05352f32370aa14beb29c043b2e1530.png";